<template>
    <div class="config-promociones-one">
        <div class="config-promociones-card rounder-8 mb-4">
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ productName }}</span>
            </div>

            <div class="promociones-fields-container">
                <div class="promociones-field" v-if="clusterName">
                    <label class="promociones-field-label">LISTA DE PRECIO</label>
                    <div class="field-value-text">{{ clusterName }}</div>
                </div>

                <div class="promociones-field">
                    <label class="promociones-field-label">ESTADO ACTUAL</label>
                    <div class="field-value-text">
                        <span
                            class="promociones-status-badge"
                            :class="currentStatus ? 'status-active' : 'status-inactive'"
                        >
                            {{ currentStatus ? 'Activo' : 'Inactivo' }}
                        </span>
                    </div>
                </div>

                <div class="promociones-field">
                    <label class="promociones-field-label">NUEVO ESTADO</label>
                    <div class="toggle-container">
                        <label class="toggle-switch">
                            <input
                                type="checkbox"
                                v-model="newStatus"
                            />
                            <span class="toggle-slider"></span>
                        </label>
                        <span class="toggle-label">{{ newStatus ? 'Activo' : 'Inactivo' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="save" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'config-promociones-one',
    props: {
        propHead: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            newStatus: false,
            saving: false,
        };
    },
    computed: {
        productName() {
            const row = this.propHead.row || {};
            return row.long_name || (row.product ? row.product.long_name : '');
        },
        clusterName() {
            return this.propHead.row?.store_name || '';
        },
        currentStatus() {
            const row = this.propHead.row || {};
            return !!row.active_promotion;
        },
    },
    created() {
        const row = this.propHead.row || {};
        this.newStatus = !!row.active_promotion;
    },
    methods: {
        ...mapActions(['update']),
        save() {
            this.saving = true;
            this.update({
                url: '/api/products/config_promociones/update/',
                params: {
                    id: this.propHead.row.id,
                    active_promotion: this.newStatus,
                },
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Estado de promoción actualizado correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar el estado.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar el estado.', { timer: 5, showCloseIcn: true });
                }
            });
        },
    },
};
</script>

<style scoped>
.config-promociones-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.promociones-fields-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.promociones-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.promociones-field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.field-value-text {
    font-size: 0.95rem;
    color: #1f2937;
    padding: 6px 0;
}

.promociones-status-badge {
    display: inline-block;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 20px;
    white-space: nowrap;
}

.status-active {
    background: #d1fae5;
    color: #065f46;
}

.status-inactive {
    background: #f3f4f6;
    color: #4b5563;
}

.toggle-container {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 0;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 26px;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e5e7eb;
    transition: .3s;
    border-radius: 26px;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
    background-color: #1AA179;
}

.toggle-switch input:checked + .toggle-slider:before {
    transform: translateX(22px);
}

.toggle-label {
    font-size: 0.95rem;
    font-weight: 500;
    color: #374151;
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
